export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const LOGIN_URL = process.env.REACT_APP_LOGIN_URL;

export const ROLE = {
  OWNER: 1,
  ADMIN: 2,
  MEMBER: 3
};

export const LANGUAGE = {
  NAME: {
    JAPANESE: '日本語',
    KOREAN: '韓国語',
  },
  CODE: {
    JAPANESE: 'ja',
    KOREAN: 'ko',
  },
};

export const FORM_URL = process.env.REACT_APP_FORM_URL;

export const API_URL = 'https://api.tools.game.10antz.co.jp/api/v1.0/';

export const LANGUAGE_DICTIONARY = {
  ja: {
    name: '名前',
    last_name: '姓',
    first_name: '名',
    name_kana: '名前（カナ）',
    last_name_kana: '姓（カナ）',
    first_name_kana: '名（カナ）',
    email: 'メールアドレス',
    tel: '電話番号',
    post: '郵便番号（半角数字）',
    address1: '都道府県',
    address2: '市区町村',
    address3: '番地等',
    last_name_placeholder: '例: 山田',
    first_name_placeholder: '例: 太郎',
    last_name_kana_placeholder: '例: ヤマダ',
    first_name_kana_placeholder: '例: タロウ',
    email_placeholder: '例: info@example.com',
    tel_placeholder: '例: 09000000000',
    post_placeholder: '例: 123456',
    address1_placeholder: '例: 東京都',
    address2_placeholder: '例: 新宿区西新宿',
    address3_placeholder: '例: 1-2-3 ○×ビル406号室',
    gender: '性別',
    genderList: ['男性', '女性'],
    age: '年齢',
    ageList: ['10歳以下', '10歳~19歳', '20歳~29歳', '30歳~39歳', '40歳~49歳', '50歳~59歳', '60歳以上']
  },
  ko: {
    name: '名前',
    last_name: '姓',
    first_name: '名',
    name_kana: '名前（カナ）',
    last_name_kana: '姓（カナ）',
    first_name_kana: '名（カナ）',
    email: 'メールアドレス',
    tel: '電話番号',
    post: '郵便番号（半角数字）',
    address1: '都道府県',
    address2: '市区町村',
    address3: '番地等',
    last_name_placeholder: '例: 山田',
    first_name_placeholder: '例: 太郎',
    last_name_kana_placeholder: '例: ヤマダ',
    first_name_kana_placeholder: '例: タロウ',
    email_placeholder: '例: info@example.com',
    tel_placeholder: '例: 09000000000',
    post_placeholder: '例: 123456',
    address1_placeholder: '例: 東京都',
    address2_placeholder: '例: 新宿区西新宿',
    address3_placeholder: '例: 1-2-3 ○×ビル406号室',
    gender: '性別',
    genderList: ['男性', '女性'],
    age: '年齢',
    ageList: ['10歳以下', '10歳~19歳', '20歳~29歳', '30歳~39歳', '40歳~49歳', '50歳~59歳', '60歳以上']
  }
}
